import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import login from '../view/login/login'
import home from '../view/home/home'
import orderList from '../view/orderList'
import orderDetail from '../view/orderDetail'
import dishList from '../view/dishList'
import bill from '../view/bill'
import billMonth from '../view/billMonth'
import memberList from '../view/memberList'
import consumptionRecords from '../view/consumptionRecords'
import repertoryList from '../view/repertoryList'


Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      hidden: true,
      meta: {
        alive:true
     }
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail
    },
    {
      path: '/bill',
      name: 'bill',
      component: bill
    },
    {
      path: '/dishList',
      name: 'dishList',
      component: dishList
    },
    {
      path: '/billMonth',
      name: 'billMonth',
      component: billMonth,
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/memberList',
      name: 'memberList',
      component: memberList
    },
    {
      path: '/consumptionRecords',
      name: 'consumptionRecords',
      component: consumptionRecords
    },
    {
      path: '/repertoryList',
      name: 'repertoryList',
      component: repertoryList
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js